import { DeleteVMButton } from 'features/kestrelViewer/ui/tools/DeleteVMButton'
import { ExportControlsSubmenu } from 'features/kestrelViewer/ui/tools/exportControls/ExportControlsSubmenu'
import { SettingsButton } from 'features/kestrelViewer/ui/tools/SettingsButton'
import React from 'react'

export const MiscTools: React.FC = () => {
  // Wrapper for non-mode and non-toggle tooling
  return (
    <div>
      <ExportControlsSubmenu />
      <DeleteVMButton />
      <SettingsButton />
    </div>
  )
}
